<template>
  <div v-gutter="showCountry ? 8 : 0"
    :class="{'flex': !isFormColumn,'flex-direction-column':column && !isFormColumn}">
    <template v-if="!isFormColumn">
      <div :class="{'gj-mb16':column}">
        <gj-required v-if="column">国家</gj-required>
        <gj-select
            v-if="showCountry"
            v-model="countryValue"
            :options="countryOptions"
            type="multi-check"
            placeholder="全部国家"
            :width="width[0]"
            clearable
            :disabled="disabled"
            :filterable="false"
            @change="countryValueChange($event)"
            key="country"
        ></gj-select>
      </div>
      <div>
        <gj-required v-if="column">店铺</gj-required>
        <gj-select
            v-if="showMarket"
            v-model="marketValue"
            :options="displayMarketOptions"
            :search-comparator="(e, searchText) => `${e.text}${e.countryCode || ''}`.toLowerCase().includes(searchText.toLowerCase())"
            type="multi-check"
            placeholder="全部店铺"
            :width="width[1]"
            clearable
            :disabled="disabled"
            :filterable="false"
            @change="marketValueChange($event)"
            key="market"
        >
          <template v-slot:content="{ item }">
            <span class="font12">
              {{item.text}}
              <span class="country">{{item.countryCode}}</span>
              <span v-if="item.status==='Inactive'" class="country">停用</span>
            </span>
          </template>
        </gj-select>
      </div>
    </template>
    <template v-else>
      <el-row>
        <el-col :span="12">
          <el-form-item label="适用国家">
            <gj-select
                v-if="showCountry"
                v-model="countryValue"
                :options="countryOptions"
                type="multi-check"
                placeholder="全部国家"
                :width="width[0]"
                clearable
                :disabled="disabled"
                :filterable="false"
                @change="countryValueChange($event)"
                key="country"
            ></gj-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="适用店铺">
            <gj-select
                v-if="showMarket"
                v-model="marketValue"
                :options="displayMarketOptions"
                :search-comparator="(e, searchText) => `${e.text}${e.countryCode || ''}`.toLowerCase().includes(searchText.toLowerCase())"
                type="multi-check"
                placeholder="全部店铺"
                :width="width[1]"
                clearable
                :disabled="disabled"
                :filterable="false"
                @change="marketValueChange($event)"
                key="market"
            >
              <template v-slot:content="{ item }">
                <span class="font12">
                  {{item.text}}
                  <span class="country">{{item.countryCode}}</span>
                  <span v-if="item.status==='Inactive'" class="country">停用</span>
                </span>
              </template>
            </gj-select>
          </el-form-item>
        </el-col>
      </el-row>
    </template>
  </div>
</template>

<script>
  import GjSelect from "./gj-select";
  import {defaultVal, isMeaningful, transformToMap} from "../../utils/common";
  import {mapGetters} from "vuex";
  export default {
    name: "gj-country-server-select",
    components: {GjSelect},
    props: {
      //是否上下排列，例子成本中心-商品成本-导入
      column:null,
      // 是否为表单选择, 例子 关怀邮件 -- 新增关怀邮件
      isFormColumn: {
        type: Boolean,
        default: false
      },
      value: null,
      showCountry: {
        type: Boolean,
        default: true
      },
      showMarket: {
        type: Boolean,
        default: true
      },
      isActive: {
        type: Boolean,
        default: false
      },
      width: {
        type: Array,
        default: () => (['140px', '170px'])
      },
      disabled: {
        type: Boolean,
        default: false
      },
      externalCountry: {
        type: Array,
        default: () => []
      },
      externalMarket: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        countryValue: [],
        marketValue: [],
        countryMap: null
      }
    },
    watch: {
      value: {
        handler(value) {
          this.countryValue = value ? defaultVal(value.countryIds, []) : [];
          this.marketValue = value ? defaultVal(value.marketIds, []) : [];
        },
        immediate: true,
        deep: true
      },
      countryOptions: {
        immediate: true,
        handler(newValue, oldValue) {
          if (isMeaningful(newValue)) {
            this.countryMap = transformToMap(newValue);
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        countries: 'authCountries',
        markets: 'authMarkets'
      }),
      countryOptions() {
        return this._.cloneDeep(isMeaningful(this.externalCountry) && this.externalCountry.length > 0 ? this.externalCountry : this.countries);
      },
      marketOptions() {
        let markets = this.isActive ? this.markets.filter(item => item.status==='Active') : this.markets
        return this._.cloneDeep(isMeaningful(this.externalMarket) && this.externalMarket.length > 0 ? this.externalMarket : markets);
      },
      displayMarketOptions() {
        if (this.countryValue.length > 0 && this.countryMap) {
          return this.marketOptions.filter(option =>
            this.countryValue.some(id => {
              const item = this.countryMap[id];
              return item && item.text === option.countryCode;
            }));
        } else {
          return this.marketOptions;
        }
      }
    },
    methods: {
      countryValueChange() {
        this.marketValue = [];
        this.marketValueChange();
      },
      marketValueChange() {
        if (this.$listeners['input-market-option']) {
          this.$emit('input-market-option', this.marketOptions.filter(option => {
            return this.marketValue.includes(option.id);
          }));
        }
        this.$emit('input', {
          countryIds: this.countryValue,
          marketIds: this.marketValue
        });
      }
    },
  }
</script>

<style lang="scss" scoped>
  .country {
    margin-left: 8px;
    color: #bfbfbf;
  }
</style>
